
import { QUOTATIONS_TABLE_SET_FILTERS } from 'Redux/types/tableQuotationsTypes';

import { getQuotationsSlopes, setConfigurationQuotationsSlopes } from './quotationSlopes';
import { getQuotationsEmitted, setConfigurationQuotationsEmitted } from './quotationsEmitted';
import { getQuotationsSlopesToEmit, setConfigurationQuotationsSlopesToEmit } from './quotationsSlopesToEmit';


// ------------------------------- ------------------------------- ------------------------------- -------------------------------
// Filtros del listado de cotizaciones
const filtersQuotationsTable = (data) => ({
  type: QUOTATIONS_TABLE_SET_FILTERS,
  payload: data,
});

const setFiltersQuotationsTable = (data) => (dispatch) => dispatch(filtersQuotationsTable(data));


// ------------------------------- ------------------------------- ------------------------------- -------------------------------
export {
  setFiltersQuotationsTable,

  getQuotationsSlopes,
  setConfigurationQuotationsSlopes,

  getQuotationsEmitted,
  setConfigurationQuotationsEmitted,

  getQuotationsSlopesToEmit,
  setConfigurationQuotationsSlopesToEmit,
};
